export enum ViewMode {
  TABLE = "TABLE",
  TREE = "TREE",
  SEARCH = "SEARCH",
}
